import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { appConstants } from "../constants/appConstants";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-login-component",
  templateUrl: "./login-component.component.html",
  styleUrls: ["./login-component.component.scss"],
})
export class LoginComponentComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  isInvalid: boolean = false;
  islogin: boolean = false;
  constructor(
    private _router: Router,
    private _fb: FormBuilder,
    private _authService: AuthenticationService
  ) {
    // this._authService.logOut();
    this.islogin = this._authService.isLoggedIn();
  }

  //http://localhost:4200/Login#session_state=82b648df-6995-4794-bc41-4d47965d4f2b&access_token=eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJPejIyVGU3STZBWlFKeTU2UlVjZlNfaGFqNmIwUnJGZVlFZGhtV1JHcXZnIn0.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.PNNVjjvNDFBGrq3ueCVgsV9T-ZqHFRZu1gFicSMmbGhRX499yyg817xLye8zhPrCZoYzHBVU5iX85I9Ejm6chHwbMawf5Xx0wNP1o_LCI0ictn7_qB1inx0JJrlz6FUJjEqBRRLcbZYeeFXMPxeyEsnLH4Tz3uG7mH39Cfhj3z09xVoGWTZbErN4wl2Sp0CVqTzqnlQOeojQMBr7Tg7YNsANs9kCtgfmguqhCJQ7xSHr5N--pc0hBzkFai1pFa8SgSh5KO2IanwGSU0gF6O-3qvr6-qYoLcIZctY-uuilbV3qGDGHYhLWIRdcK1RNXXLdUaBgSqD5_oO2Uy4ZpifXA&token_type=Bearer&expires_in=43200

  ngOnInit() {
    this.buildForm();
    if(this.islogin){
      this._router.navigate(['/Refund-request']);
    }
    const frag = window.location.hash;
    if (frag && frag.length > 0){
      this.parseHashAccessToken(frag);
    }
  }

  parseHashAccessToken (frag:string)  {
    let splitHast = frag.split('&')
    let accessTokenString = splitHast[1];
    let accessToken = accessTokenString.replace('access_token=', '');
    this._authService.setToken(accessToken);
    this.islogin = true;
    this._router.navigate(['/Refund-request']);
  }


  buildForm() {
    this.loginForm = this._fb.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });
    return this.loginForm;
  }
  changeEmail() {
    this.isInvalid = false;
  }
  submitLogin(form: FormGroup) {
    window.location.href = environment.keyClockSignInUrl;
  }

  ngOnDestroy() {}
}
